import { CheckoutField } from 'app/model/approval/approval-detail-model';
import { TaxAddressInformation, BookingApproval, Benefit } from '../../model/booking/my-booking-model-v2';
import { PaymentChannelType } from '../../model/constant';
export class MyBookingSection {
    data: BookingInfoSection;

    constructor(data: BookingInfoSection) {
        this.data = data;
    }
}

export class OperationDateTime {
    date: string;
    timeFrom: string;
    timeUntil: string;

    constructor(date: string, timeFrom: string, timeUntil: string) {
        this.date = date;
        this.timeFrom = timeFrom;
        this.timeUntil = timeUntil;
    }
}

export class GuestAmount {
    adult: number;
    child: number;
    childrenAge: number[];

    constructor(adult: number, child: number, childrenAge?: number[]) {
        this.adult = adult;
        this.child = child;
        this.childrenAge = childrenAge;
    }
}


export enum MyBookingDataSctionType {
    BOOKING,
    ROOM,
    BOOKER,
    BOOKING_DETAIL,
    TRAVELLER_INFO
}

export class BookingInfoSection {
    bookingId: number;
    wsReference: string;
    checkIn: any;
    checkOut: any;
    periodOfStay: number;
    roomAmount: number;
    occupancyInfo: any;
    maxGuest: any;
    bookingDate?: any;
    bookingTime?: any;
    bookingStatus?: BookingStatusDisPlayModel;
}

export class RoomDetailSection {
    roomTypeName: string;
    night: number;
    maxGuest: any;
    guest: string;
    specialRequest: string;
    price: number;
    offerTypeDisplay: string;
    offerType: string;
    benefits: Benefit[];
    freeCancellationDate: Date;
    currencyCode: string;
    showcancellationPolicies: boolean;
    cancellationPolicies?: CancellationPolicy[];
    policyMessages?: string[];
}

export class BookerInfoSection {
    mainBooker: boolean;
    fullName: string;
    phone: string;
    email: string;
    approval?: BookingApproval;
    paymentChannel: PaymentChannelType;
    creditTermsInfo: TaxAddressInformation;
    creditCardInfo: TaxAddressInformation;
    trueMoneyInfo: TaxAddressInformation;
    qrCodeInfo: TaxAddressInformation;
    eWalletInfo: TaxAddressInformation;
    imBankingInfo: TaxAddressInformation;
    payAtCounterInfo: TaxAddressInformation;
    checkoutFields?: CheckoutField[];
}

export class CancellationPolicy {
    fromDate: any;
    cancelFee: number;
}

export class BookingStatusDisPlayModel {
    bookingStatus: string;
    payOnDate?: any;
    cancellationDate?: any;
    approvalDate?: any;
    paymentType: string;
    cancelBy: string;
    reason?: string;
}



// WEBPACK FOOTER //
// ./src/app/components/booking-detail/booking-detail-section.ts